module.exports = __webpack_public_path__ + "img/riwayat_ijin.afc5c592.png";